import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50 hover:bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-100 text-primary-600' },
  accent: { bg: 'bg-accent-50 hover:bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-100 text-accent-600' },
  secondary: { bg: 'bg-secondary-50 hover:bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-100 text-secondary-600' },
};

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold mb-3">
            内容分类
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            探索学习路径
          </h2>
          <p className="text-foreground-500 max-w-lg mx-auto text-sm">
            无论你是新手还是老手，都能找到适合自己的内容方向
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} rounded-xl p-6 transition-colors group`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${colors.iconBg} mb-4`}>
                  <i className={`${cat.icon} text-xl`} />
                </div>
                <h3 className={`text-lg font-semibold ${colors.text} mb-2`}>{cat.name}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">{cat.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{cat.articleCount} 篇文章</span>
                  <span className={`text-sm font-medium ${colors.text} opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1`}>
                    浏览 <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}